<template>
  <button @click="onClick" :disabled="disabled">
    <slot />
    <slot name="icon" />
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    onClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
button {
  cursor: pointer;
  border: 1px solid var(--primary-color);
  padding: 7px 15px;
  border-radius: 6px;
  color: var(--primary-color);
  background-color: white;
}
button:not([disabled]):hover {
  opacity: 0.7;
}

button[disabled] {
  cursor: not-allowed;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/AppButton.vue